import { render, staticRenderFns } from "./PlaceBusstop.vue?vue&type=template&id=370bbbcf&"
import script from "./PlaceBusstop.vue?vue&type=script&lang=js&"
export * from "./PlaceBusstop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports